import * as S from './index.styles';
interface Props {
  name: string;
  isActive: boolean;
}

export default function BaseTab({ name, isActive }: Props) {
  return <S.BaseTabWrapper isActive={isActive}>{name}</S.BaseTabWrapper>;
}
